export default "__VITE_ASSET__JRzfIVN0__"